import React from 'react';

const getWeekOfMonth = (d) => {
    return Math.ceil(d.getUTCDate() / 7);
}

const MonthlyWeeklyRanking = ({ data }) => {
    if (data.length === 0) {
        return null;
    }

    const processedData = {};
    const years = new Set();

    data.forEach(item => {
        const date = new Date(item.fecha);
        const year = date.getUTCFullYear();
        const month = date.getUTCMonth(); // 0-11
        const week = getWeekOfMonth(date);
        const value = parseInt(item.valor, 10);

        years.add(year);

        if (!processedData[year]) {
            processedData[year] = {};
        }
        if (!processedData[year][month]) {
            processedData[year][month] = { weeks: {}, total: 0 };
        }
        if (!processedData[year][month].weeks[week]) {
            processedData[year][month].weeks[week] = 0;
        }
        processedData[year][month].weeks[week] += value;
    });

    const sortedWeeks = [1, 2, 3, 4, 5];
    const weeklyTotals = {};
    sortedWeeks.forEach(week => weeklyTotals[week] = 0);
    let grandTotal = 0;

    const tableRows = [];
    [...years].sort().forEach(year => {
        Object.keys(processedData[year]).sort((a,b) => a-b).forEach(month => {
            const monthName = new Date(year, month).toLocaleString('es-AR', { month: 'long' });
            let monthlyTotal = 0;
            const row = {
                year,
                month,
                monthName: `${monthName.charAt(0).toUpperCase() + monthName.slice(1)} ${year}`,
                weekData: {},
                monthlyTotal: 0
            };

            sortedWeeks.forEach(week => {
                const value = processedData[year][month].weeks[week] || 0;
                row.weekData[week] = value;
                monthlyTotal += value;
                weeklyTotals[week] += value;
            });
            row.monthlyTotal = monthlyTotal;
            grandTotal += monthlyTotal;
            tableRows.push(row);
        });
    });


    return (
        <div className="card shadow-sm mt-4">
            <div className="card-body">
                <h5 className="card-title text-center mb-3">Ranking Mensual y Semanal</h5>
                <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                        <thead className="table-dark">
                            <tr>
                                <th>Mes</th>
                                {sortedWeeks.map(week => <th key={week}>Semana {week}</th>)}
                                <th>Total Mensual</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableRows.map(row => (
                                <tr key={`${row.year}-${row.month}`}>
                                    <td>{row.monthName}</td>
                                    {sortedWeeks.map(week => <td key={week}>{row.weekData[week] || 0}</td>)}
                                    <td>{row.monthlyTotal}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr className="table-dark">
                                <td>Total Semanal</td>
                                {sortedWeeks.map(week => <td key={week}>{weeklyTotals[week]}</td>)}
                                <td>{grandTotal}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default MonthlyWeeklyRanking;